import { setCookie, getCookie } from "../wcl-helpers";

document.addEventListener('DOMContentLoaded', function () {
   /*
   * Add a fill for the heart before Ajax starts working 
   */
   const favoutiteRoomsButtons = document.querySelectorAll('.simplefavorite-button');

   favoutiteRoomsButtons.forEach(btn => {
      btn.addEventListener('click', e => {
         e.preventDefault();

         if (btn.classList.contains('active')) {
            btn.classList.remove('filled-heart');
            btn.classList.add('transparent-heart');
         } else {
            btn.classList.remove('transparent-heart');
            btn.classList.add('filled-heart');
         }
      });
   });


   /*
   * Function for adding active class to a favorite button
   */
   function addActiveClassToButton(postId) {
      const favoriteButtons = document.querySelectorAll('.simplefavorite-button');
      favoriteButtons.forEach(function (button) {
         const buttonPostId = button.getAttribute('data-postid');
         if (buttonPostId === postId) {
            button.classList.add('active');
         }
      });
   }


   /*
   * Function for removing active class from a favorite button
   */
   function removeActiveClassFromButton(postId) {
      const favoriteButtons = document.querySelectorAll('.simplefavorite-button');
      favoriteButtons.forEach(function (button) {
         const buttonPostId = button.getAttribute('data-postid');
         if (buttonPostId === postId) {
            button.classList.remove('active');
         }
      });
   }


   /*
   * Function for saving a value to a cookie
   */
   function saveToCookie(postId) {
      let favoritePosts = getCookie('favoritePosts');
      favoritePosts = favoritePosts ? JSON.parse(favoritePosts) : [];
      if (!favoritePosts.includes(postId)) {
         favoritePosts.push(postId);
         setCookie('favoritePosts', JSON.stringify(favoritePosts), 7); // Updating cookies
      }
   }


   /*
   * Function for removing a value from a cookie
   */
   function removeFromCookie(postId) {
      let favoritePosts = getCookie('favoritePosts');
      favoritePosts = favoritePosts ? JSON.parse(favoritePosts) : [];
      favoritePosts = favoritePosts.filter(function (id) {
         return id !== postId;
      });
      setCookie('favoritePosts', JSON.stringify(favoritePosts), 7); // Updating cookies
   }


   /*
   * Button click handler .simplefavorite-button
   */
   document.addEventListener('click', function (event) {
      if (event.target && event.target.classList.contains('simplefavorite-button')) {
         const postId = event.target.getAttribute('data-postid');
         if (postId) {
            const isActive = event.target.classList.contains('active');
            if (isActive) {
               // Deleting a class and updating cookies
               removeActiveClassFromButton(postId);
               removeFromCookie(postId);
            } else {
               // Adding a class and updating a cookie
               saveToCookie(postId);
               event.target.classList.add('active');
            }
         }
      }
   });


   /*
   * Check cookies and add active class on page load
   */
   let favoritePosts = getCookie('favoritePosts');
   favoritePosts = favoritePosts ? JSON.parse(favoritePosts) : [];
   favoritePosts.forEach(function (postId) {
      addActiveClassToButton(postId);
   });
});